const api = {
  addNotification: () => `/CustomerInsightNotifications`,

  deleteNotification: (id) => `/CustomerInsightNotifications/${id}`,

  updateNotification: (id) => `/CustomerInsightNotifications/${id}`,

  getNotification: (id) => `/CustomerInsightNotifications/${id}`,

  searchWithText: (searchTerm) =>
    searchTerm
      ? `/CustomerInsightNotifications/search/searchTerm=${searchTerm}`
      : `/CustomerInsightNotifications/search`,

  getNotificationsByAccount: (customerNumber) =>
    `/CustomerInsightNotifications/customer/${customerNumber}/notifications`,

  addAccountToNotification: (id) => `/CustomerInsightNotifications/${id}/accounts`,

  deleteAccountFromNotification: (id) => `/CustomerInsightNotifications/accounts/${id}`,

  getAccountsForNotification: (id) => `/CustomerInsightNotifications/${id}/accounts`,

  sendNotificationEmail: (id) => `/CustomerInsightNotifications/${id}/send-email`,
};

export default api;
